<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-danger opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <h1 class="display-2 text-white">Hola {{ $store.getters['auth/contacto'].nombre }} {{ $store.getters['auth/contacto'].apellido }}</h1>
                        <p class="text-white mt-0 mb-5">Esta es tu página de perfil, donde podras modificar tus datos personales.</p>
                        <a href="#editPerfil" class="btn btn-info">Editar Perfil</a>
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <!--<a href="#">-->
                                        <!--<img src="img/theme/team-4-800x800.jpg" class="rounded-circle">-->
                                    <!--</a>-->
                                    <div class="avatar-perfil bg-gradient-warning media align-items-center">
                                        <p>{{ $store.getters['auth/userAvatarName'] }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">22</span>
                                            <span class="description">Friends</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Photos</span>
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description">Comments</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                    {{ $store.getters['auth/contacto'].nombre }} {{ $store.getters['auth/contacto'].apellido }}<span class="font-weight-light">, 27</span>
                                </h3>
                                <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Bucharest, Romania
                                </div>
                                <div class="h5 mt-4">
                                    <i class="ni business_briefcase-24 mr-2"></i>Solution Manager - Creative Tim Officer
                                </div>
                                <div>
                                    <i class="ni education_hat mr-2"></i>University of Computer Science
                                </div>
                                <!--<hr class="my-4" />-->
                                <!--<p>Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music.</p>-->
                                <!--<a href="#">Show more</a>-->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1" id="editPerfil">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Editar Cuenta</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <base-button type="primary" size="sm" @click="submitContact">Guardar</base-button>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Información del usuario</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Nombre</label>
                                                <input alternative="" class="form-control form-control-alternative" v-model="one.nombre"/>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Apellido</label>
                                                <input alternative="" class="form-control form-control-alternative" v-model="one.apellido"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Email Personal</label>
                                                <input alternative="" class="form-control form-control-alternative" v-model="correos[0]"/>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Email Trabajo</label>
                                                <input alternative="" class="form-control form-control-alternative" v-model="correos[1]"/>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Otro Email</label>
                                                <input alternative="" class="form-control form-control-alternative" v-model="correos[2]"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <div class="pl-lg-4">
                                    <div class="row align-items-center">
                                        <div class="col-8">
                                            <h6 class="heading-small text-muted mb-4">Cambio de contraseña</h6>
                                        </div>
                                        <div class="col-4 text-right">
                                            <base-button type="primary" size="sm" @click="submitPass">Guardar</base-button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input alternative="" label="Contraseña actual" type="password" input-classes="form-control-alternative" v-model="formSecurity.pass1"/>
                                        </div>
                                        <div class="col-md-12">
                                            <base-input alternative="" label="Nueva contraseña" type="password" input-classes="form-control-alternative" v-model="formSecurity.pass2"/>
                                        </div>
                                        <div class="col-md-12">
                                            <base-input alternative="" label="Confirmar contraseña" type="password" input-classes="form-control-alternative" v-model="formSecurity.pass3"/>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import isArray from 'lodash/isArray'
     import get from 'lodash/get'
    export default {
        name: 'user-profile',
        data() {
            return {
                formSecurity: {
                    pass1: null,
                    pass2: null,
                    pass3: null
                }
            }
        },
        computed: {
            ...mapGetters('auth', ['one']),
            correos() {
                if (!isArray(get(this.one, 'email'))) {
                    this.$set(this.one, 'email', [])
                }
                return this.one.email
            },
            id() {
                return this.$store.getters['auth/contacto'].id
            }
        },
        methods: {
            ...mapActions('auth', ['save', 'updPass', 'getBy']),
            getAll() {
                Promise.all ([
                    this.getBy({ id: this.id })
                ]).then(() => {
                })
            },
            submitContact(){
                this.save(this.one)
                .then((resp) => {
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'success',
                        speed: 1000,
                        duration: 500,
                        text: 'Los cambios se han guardado exitosamente.'
                    });
                    this.getAll()
                }).catch((resp) => {
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'error',
                        speed: 1000,
                        duration: 500,
                        text: 'Hubo un error al guardar los cambios.'
                    });
                })
            },
            submitPass(){
                this.updPass(this.formSecurity)
                .then((resp) => {
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'success',
                        speed: 1000,
                        duration: 500,
                        text: 'Los cambios se han guardado exitosamente.'
                    });
                    setTimeout(() => {
                        this.$store.dispatch('auth/logout')
                        .then(() => {
                            this.$router.push({ path: '/login' })
                        })
                    }, 3000)
                }).catch((error) => {
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'error',
                        speed: 1000,
                        duration: 500,
                        text: error.message
                    });                    
                })
            }
        },
        mounted() {
            this.getAll()
        }
  };
</script>
<style>
    .avatar-perfil {
        width: 180px;
        height: 180px;
        max-width: 180px;
        border-radius: 50%;
        -webkit-transform: translate(-50%, -30%);
        transform: translate(-50%, -30%);
        position: absolute;
        left: 50%;
        -webkit-transition: all 0.15s ease;
        transition: all 0.15s ease;
    }

    .avatar-perfil:hover {
        -webkit-transform: translate(-50%, -33%);
        transform: translate(-50%, -33%);
    }

    .avatar-perfil p {
        color: #fff;
        font-weight: 600;
        font-size: 3.5rem;
        margin: auto;
    }

    .vue-notification {
        margin-top: 15px;
    }
</style>